import React, { useEffect, useState } from "react";
import { buildVersion } from "../services/buildInfo";
import LinkedInTag from "../components/LinkedInTag";

function ThankYou() {
  const [executed, setExecuted] = useState(false);

//   useEffect(() => {
//     // Dynamically load the Google Tag Manager script
//     const script = document.createElement("script");
//     script.async = true;
//     script.src = "https://www.googletagmanager.com/gtag/js?id=AW-736858127";
//     document.head.appendChild(script);

//     // After the script loads, initialize gtag
//     script.onload = () => {
//       window.dataLayer = window.dataLayer || [];
//       function gtag() {
//         window.dataLayer.push(arguments);
//       }
//       window.gtag = gtag;

      
      
//  // Retrieve user data from localStorage
//  const userData = localStorage.getItem("userData");
//  const retrievedData = userData ? JSON.parse(userData) : null;
//       // Set user data if available
//       if (retrievedData && retrievedData.mobile) {
//         window.gtag("js", new Date());
//       window.gtag("config", "AW-736858127", { allow_enhanced_conversions: true });
//       window.gtag("set", "user_data", {
//           phone_number: retrievedData.mobile,
//         });
//       window.gtag('event', 'conversion', {'send_to': 'AW-736858127/r6u3CN_v1J4YEI-grt8C'});
//       }else{
//         window.gtag("js", new Date());
//         gtag('config', 'AW-736858127');
//         window.gtag('event', 'conversion', {'send_to': 'AW-736858127/r6u3CN_v1J4YEI-grt8C'});
//       }
//       // Track form submission event
//       window.gtag("event", "form_submit", {
//         send_to: "AW-736858127",
//       });

      
//     }

// // Remove userData from localStorage after 4 seconds using a separate function
// function removeUserData() {
//   localStorage.removeItem("userData");
//   }
//   setTimeout(removeUserData, 4000);

//     if (!executed) {
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         event: "savingsAccount_ty_eligible",
//       });

//       console.log("dataLayer", window.dataLayer);

//       if(window.lintrk){
//         window.lintrk("track",{conversion_id:4997500})
//       }
//       setExecuted(true);
//     }
//     // Initializing the Data Layer on the window object
//     window.adobeDataLayer = window.adobeDataLayer || [];
//     // Setting Page Level and user-specific variables
//     window.adobeDataLayer.push({
//       event: "pageView",
//       web: {
//         webPageDetails: {
//           pageViews: {
//             value: 1,
//           },
//           name: "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:eligible thankyou page",

//           URL: window.location.href,
//           isErrorPage: "False",
//         },
//       },
//       _icicibank: {
//         channelInfo: {
//           version: buildVersion,
//           name: "nli",
//         },
//         pageInfo: {
//           language: "en",
//           country: "in",
//           pageType: "campaign",
//           virtualPageView: "no vpv",
//           journey: "na",
//           subJourney: "na",
//           subSubJourney: "na",
//         },
//         userInfo: {
//           userType: "na",
//         },
//         errorInfo: {
//           errorType: "na",
//           errorDetails: "na",
//         },
//       },
//     });

   


//   }, []);








  return (
    <>

      {/* <LinkedInTag/> */}
      <article className="thankyou_sec">
        <div className="container ">
          <div className="tick">
            <img
              src="../dist/img/tick.webp"
              alt="tick"
              width="100"
              height="100"
              className="img-fluid"
            />
          </div>
          <div className="thankyou_txt">
            <p>
              Thank You for your interest in
              <br className="d-block " /> ICICI Bank Savings Account.
              <br className="d-md-none d-block" />
              We are assessing your eligibility
              <br className="d-block" /> Our associates will get back to you
              soon.{" "}
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default ThankYou;
